import { render, staticRenderFns } from "./POS-Layout.vue?vue&type=template&id=6ece711f"
import script from "./POS-Layout.vue?vue&type=script&lang=js"
export * from "./POS-Layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports